/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */
/* flow-disable */

import React, { PropTypes } from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import GrayPanel from '../../../../components/GrayPanel';
import s from './EditDistrict.css';
import { fetchDistrictList, setCurrentDistrict } from '../../../../actions/app';
import { connect } from 'react-redux';
import Link from '../../../../components/Link';
import _ from 'lodash';
import FormRow from '../../../../components/FormRow';

const btnStyles = { margin: '10px' };

class EditDistrict extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  state = {}

  initialDistrict = null;

  componentWillMount() {
    // this.props.setCurrentDistrict(this.props.teryt);
    !this.props.app_districts.areDistrictsFetched || !this.props.app_districts.districtsList ?
      this.props.fetchDistrictList()
      .then(r => {
        const district = _.find(r, v => v.teryt == this.props.teryt);
        this.setState({ ...district }, () => this.initialDistrict = district );
      }) : null;
  }

  componentDidMount() {
    const district = _.find(this.props.app_districts.districtsList, v => v.teryt == this.props.teryt);
    this.setState({ ...district }, () => this.initialDistrict = district );
  }

  addNewBank = () => this.setState({
    ...this.state,
    bankAccounts: [...this.state.bankAccounts, { number: '', name: 'nowy' }],
  });
  deleteBank = bank => this.setState({
    ...this.state,
    bankAccounts: _.filter(this.state.bankAccounts, v => v.number != bank.number),
  });

  render() {
    return (
      <GrayPanel style={{ marginTop: '20px' }} title={this.state.name}>
        <div className="row">
          <div className="col-sm-2" />
          <div className="col-sm-8">
            <FormRow disabled label="Nazwa" name="name" onChange={e => this.onChange(e)} value={this.state.name} />
            <FormRow disabled label="Miejsce załatwienia" name="placeOfSettling" onChange={e => this.onChange(e)} value={this.state.placeOfSettling} />
            <FormRow disabled label="Miejscowość" name="place" onChange={e => this.onChange(e)} value={this.state.place} />
            <FormRow disabled label="Ulica" name="street" onChange={e => this.onChange(e)} value={this.state.street} />
            <FormRow disabled label="Numer budynku" name="nrBuilding" onChange={e => this.onChange(e)} value={this.state.nrBuilding} />
            <FormRow disabled label="Numer lokalu" name="nrLocal" onChange={e => this.onChange(e)} value={this.state.nrLocal} />
            <FormRow disabled label="Kod pocztowy" name="zipCode" onChange={e => this.onChange(e)} value={this.state.zipCode} />
            <FormRow disabled label="Telefon" name="phone" onChange={e => this.onChange(e)} value={this.state.phone} />
            <FormRow disabled label="Fax" name="fax" onChange={e => this.onChange(e)} value={this.state.fax} />
            <FormRow disabled label="Strona www" name="pageWWW" onChange={e => this.onChange(e)} value={this.state.pageWWW} />
            <FormRow disabled label="Strona BIP" name="pageBIP" onChange={e => this.onChange(e)} value={this.state.pageBIP} />
            <FormRow disabled label="Oficjalny email" name="email" onChange={e => this.onChange(e)} value={this.state.email} />
            <FormRow disabled label="Teryt" name="teryt" onChange={e => this.onChange(e)} value={this.state.teryt} />
            <FormRow disabled label="Opis" name="description" onChange={e => this.onChange(e)} value={this.state.description} />
          </div>
          <div className="col-sm-2" />
        </div>
        {this.state.bankAccounts && this.state.bankAccounts.length > 0 ? <hr /> : null}
        {this.state.bankAccounts && this.state.bankAccounts.length > 0 ?
          <div className="row">
            <h3>Konta bankowe</h3>
            {this.state.bankAccounts.map((v, i) =>
              <div className="container-fluid" key={i}>
                <div className="col-xs-5" style={{padding: '7px'}}>{v.name}</div>
                <div className="col-xs-5">
                  <input disabled type="text" className="form-control" value={v.number} name={v.number} />
                </div>
                <div className="col-xs-2">
                  <button type="submit" onClick={() => this.deleteBank(v)} style={{...btnStyles, marginTop: '0'}} className="btn btn-danger pull-right">-</button>
                </div>
              </div>
            )}

          </div> : null
        }
        <div className="container-fluid">
          <button type="submit" onClick={() => this.addNewBank()} style={{...btnStyles, marginTop: '0'}} className="btn btn-primary pull-right">Ddodaj</button>
        </div>
        <hr />
        <div className="row">
          <div className="pull-right">
            <a href={this.redirectURL} style={btnStyles} className="btn btn-danger">Anuluj</a>
            <button type="submit" onClick={() => this.add()} style={btnStyles} className="btn btn-primary">Dodaj</button>
          </div>
        </div>
      </GrayPanel>
    );

  }
}

const mapState = (state) => ({
  app_districts: state.app.app_districts,
  district: state.app.currentDistrict,
});

const mapDispatch = {
  fetchDistrictList,
  setCurrentDistrict,
};

export default withStyles(s)(connect(mapState, mapDispatch)(EditDistrict));



// WEBPACK FOOTER //
// src/routes/admin/districts/edit_district/EditDistrict.js